import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  // linkActiveClass: 'is-active',
  base: '/',
  routes: [
      {
      path: '/auth',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          path: 'login',
          name: 'login',
          component: () => import('@/views/pages/Login'),
        },
        {
          path: 'logout',
          name: 'logout',
          component: () => import('@/views/pages/Logout'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'recoveryPassword',
          name: 'recoveryPassword',
          component: () => import('@/views/pages/RecoveryPassword'),
        },
        {
          path: 'recoveryPassword/:resetToken',
          name: 'recoveryPasswordToken',
          component: () => import('@/views/pages/ChangePassword'),
          props: true,
        },
      ],
    },
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: 'test',
          name: 'test',
          component: () => import('@/views/pages/Test'),
        },
        // Dashboard
        {
          name: 'Tablero principal',
          path: '',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        // Altas
        {
          name: 'Staff',
          path: '/alta/staff',
          component: () => import('@/views/abms/altas/Staff'),
          meta: {
            permission: 'M_parametros',
          },
        },
        {
          name: 'Alta Staff',
          path: '/alta/staffForm/:mode/user/:id',
          component: () => import('@/views/abms/altas/StaffForm'),
          props: function (route) {
            return {
              id: Number(route.params.id),
              mode: route.params.mode,
            }
          },
          meta: {
            permission: 'M_parametros',
          },
        },
        {
          name: 'Alta Jugador',
          path: '/alta/jugadores/:mode/user/:id',
          component: () => import('@/views/abms/altas/JugadoresForm'),
          props: castRouteParams,
          meta: {
            permission: 'M_jugadores',
          },
        },
        {
          name: 'Ligas',
          path: '/alta/ligas',
          component: () => import('@/views/abms/altas/Liga'),
          meta: {
            permission: 'M_parametros',
          },
        },
        {
          name: 'Cargos',
          path: '/alta/cargos',
          component: () => import('@/views/abms/altas/Cargo'),
          meta: {
            permission: 'M_parametros',
          },
        },
        {
          name: 'Club',
          path: '/alta/club',
          component: () => import('@/views/abms/altas/Club'),
          meta: {
            permission: 'M_parametros',
          },
        },
        {
          name: 'Contactos',
          path: '/alta/contacto',
          component: () => import('@/views/abms/altas/Contactos'),
          meta: {
            permission: 'M_parametros',
          },
        },
        {
          name: 'Alta Scouting',
          path: '/alta/scouting/:mode/scout/:id',
          component: () => import('@/views/abms/altas/ScoutingForm'),
          props: function (route) {
            return {
              id: Number(route.params.id),
              mode: route.params.mode,
            }
          },
          meta: {
            permission: 'M_scouting_edita',
          },
        },
        {
          name: 'Roles',
          path: '/alta/roles',
          component: () => import('@/views/abms/altas/Role'),
          meta: {
            permission: 'M_parametros',
          },
        },
        {
          name: 'Alta Litigio',
          path: '/alta/litigio/:mode/:id',
          component: () => import('@/views/abms/altas/LitigioForm'),
          props: function (route) {
            return {
              id: Number(route.params.id),
              mode: route.params.mode,
            }
          },
          meta: {
            permission: 'M_legales_edita',
          },
        },
        {
          name: 'permission-denied',
          path: 'permission-denied',
          component: () => import('@/views/pages/permissionDenied'),
        },
        {
          name: 'Alta Informe',
          path: '/alta/informe/:mode/:id',
          component: () => import('@/views/abms/altas/InformeForm'),
          props: function (route) {
            return {
              id: Number(route.params.id),
              mode: route.params.mode,
            }
          },
          meta: {
            permission: 'M_informes_edita',
          },
        },
        // FALTAN LOS PERMISOS
        {
          name: 'Sponsor',
          path: '/alta/sponsor',
          component: () => import('@/views/abms/altas/Sponsor'),
          meta: {
            permission: 'M_parametros',
          },
        },
        {
          name: 'Banco',
          path: '/alta/banco',
          component: () => import('@/views/abms/altas/Banco'),
          meta: {
            permission: 'M_parametros',
          },
        },
        {
          name: 'Tarjeta',
          path: '/alta/tarjeta',
          component: () => import('@/views/abms/altas/Tarjeta'),
          meta: {
            permission: 'M_parametros',
          },
        },
        {
          name: 'Tipos de Contrato',
          path: '/alta/tipo_contratos',
          component: () => import('@/views/abms/altas/TipoContratos'),
          meta: {
            permission: 'M_parametros',
          },
        },
        {
          name: 'Contratos',
          path: '/contratos/jugador/:idJugador',
          component: () => import('@/views/pages/ContratosVer'),
          props: function (route) {
            return {
              idJugador: Number(route.params.idJugador),
            }
          },
          meta: {
            permission: 'M_contratos',
          },
        },
        {
          name: 'Contratos jugador',
          path: '/contratos/jugador/:idJugador/ver_todo',
          component: () => import('@/views/abms/altas/ContratosJugador'),
          props: function (route) {
            return {
              idJugador: Number(route.params.idJugador),
            }
          },
          meta: {
            permission: 'M_contratos',
          },
        },
        {
          name: 'Listado de Jugadores',
          path: '/ver/jugadores',
          component: () => import('@/views/abms/altas/Jugadores'),
          meta: {
            permission: 'M_jugadores',
          },
        },
        {
          name: 'Alta Contrato',
          path: '/alta/contrato/jugador/:idJugador/mode/:mode/contrato/:idContrato/:idcp?',
          component: () => import('@/views/abms/altas/ContratoForm'),
          props: function (route) {
            return {
              idContrato: Number(route.params.idContrato),
              idJugador: Number(route.params.idJugador),
              mode: String(route.params.mode),
              idContratoPadre: (route.params.idcp !== undefined) ? Number(route.params.idcp) : 0,
            }
          },
          meta: {
            permission: 'M_contratos',
          },
        },
        {
          name: 'Documentaciones',
          path: '/documentaciones/jugador/:idJugador',
          component: () => import('@/views/pages/Documentaciones'),
          props: function (route) {
            return {
              idJugador: Number(route.params.idJugador),
            }
          },
          meta: {
            permission: 'M_jugadores',
          },
        },
        {
          name: 'Cobros',
          path: '/alta/recibo/recibo_id/:id/mode/:mode/jugador/:idJugador?/contrato/:idContrato?/derecho/:idDerecho?',
          component: () => import('@/views/abms/altas/CobrosForm'),
          props: function (route) {
            return {
              id: Number(route.params.id),
              mode: String(route.params.mode),
              idJugador: Number(route.params.idJugador) || 0,
              idContrato: Number(route.params.idContrato) || 0,
              idDerecho: Number(route.params.idDerecho) || 0,
            }
          },
          meta: {
            permission: 'M_cobros',
          },
        },
        {
          name: 'Adjuntar documentación',
          path: '/alta/recibo/recibo_id/:id/mode/:mode',
          component: () => import('@/components/FacturaReciboFiles'),
          props: function (route) {
            return {
              id: Number(route.params.id),
              mode: String(route.params.mode),
            }
          },
          meta: {
            permission: 'M_cobros',
          },
        },
        {
          name: 'Alta pedido de mercado',
          path: '/alta/pedidos/:id/:mode',
          component: () => import('@/views/abms/altas/PedidosMercadoForm'),
          props: castRouteParams,
          meta: {
            permission: 'M_pedidos_edita',
          },
        },
        {
          name: 'Alta consulta profesional',
          path: '/ver/consultasMedicasTurno/:id/:mode',
          component: () => import('@/views/abms/altas/ConsultaMedicaForm'),
          props: castRouteParams,
          meta: {
            permission: 'M_consultas_gestion',
          },
        },
        {
          name: 'Alta turno',
          path: '/ver/turno',
          component: () => import('@/views/abms/altas/TurnoForm'),
          props: castRouteParams,
          meta: {
            permission: 'M_consultas_turno',
          },
        },
        // BORRAR TODO ESTO
        {
          name: 'Listado de Contratos',
          path: 'ver/jugador/lista_contratos',
          component: () => import('@/views/pages/ContratosJugadores'),
          meta: {
            permission: 'M_contratos',
          },
        },
        {
          name: 'Jugadores en seguimiento',
          path: '/ver/scouting',
          component: () => import('@/views/abms/altas/Scouting'),
          meta: {
            permission: 'M_scouting',
          },
        },
        /*
        {
          name: 'Listado legales',
          path: '/ver/legales',
          component: () => import('@/views/dashboard/Dashboard'),
          meta: {
            permission: 'M_legales',
          },
        },
        */
        /*
        {
          name: 'Legal Pendientes',
          path: '/ver/legal/page1',
          component: () => import('@/views/dashboard/Dashboard'),
          meta: {
            permission: 'M_scouting',
          },
        },
        */ // Que es?
        /*
        {
          name: 'Listado turnos',
          path: '/ver/turnos/medicos',
          component: () => import('@/views/dashboard/Dashboard'),
          meta: {
            permission: 'M_scouting',
          },
        },
        */
       /*
        {
          name: 'Pendientes asignación',
          path: '/ver/turnos/pendientes',
          component: () => import('@/views/dashboard/Dashboard'),
          meta: {
            permission: 'M_scouting',
          },
        },
        */
        {
          name: 'Listado informes',
          path: '/ver/informes',
          component: () => import('@/views/abms/altas/Informe'),
          meta: {
            permission: 'M_informes',
          },
        },
        {
          name: 'Acciones informe',
          path: '/ver/informes/acciones/:id',
          component: () => import('@/views/pages/InformeVer'),
          props: castRouteParams,
          meta: {
            permission: 'M_informes',
          },
        },
        {
          name: 'Informes pendientes',
          path: '/ver/informesPendientes',
          component: () => import('@/views/abms/altas/InformePendiente'),
          meta: {
            permission: 'M_informes',
          },
        },
        {
          name: 'Pedidos de mercado',
          path: '/ver/pedidos',
          component: () => import('@/views/abms/altas/PedidosMercado'),
          meta: {
            permission: 'M_pedidos',
          },
        },
        {
          name: 'Pedidos de mercado cerrados',
          path: '/ver/pedidosCerrados',
          component: () => import('@/views/abms/altas/PedidosMercadoCerrados'),
          meta: {
            permission: 'M_pedidos',
          },
        },
        {
          name: 'Seguimiento pedidos',
          path: '/ver/pedidos/seguimiento/:id',
          component: () => import('@/views/pages/PedidosVer'),
          props: castRouteParams,
          meta: {
            permission: 'M_pedidos',
          },
        },
        {
          name: 'Asignaciones pedidos',
          path: '/ver/pedidos/asignaciones/:id',
          component: () => import('@/views/abms/altas/AsignarPedidoMercado'),
          props: castRouteParams,
          meta: {
            permission: 'M_pedidos_edita',
          },
        },
        {
          name: 'Legales',
          path: '/ver/legales/litigios',
          component: () => import('@/views/abms/altas/Litigio'),
          props: castRouteParams,
          meta: {
            permission: 'M_legales',
          },
        },
        {
          name: 'Asignaciones legales',
          path: '/ver/legales/asignaciones/:id',
          component: () => import('@/views/abms/altas/AsignarLitigio'),
          props: castRouteParams,
          meta: {
            permission: 'M_legales_edita',
          },
        },
        {
          name: 'Legales cerrados',
          path: '/ver/legales/litigiosCerrados',
          component: () => import('@/views/abms/altas/LitigioCerrados'),
          props: castRouteParams,
          meta: {
            permission: 'M_legales',
          },
        },
        {
          name: 'Seguimiento legales',
          path: '/ver/legales/seguimiento/:id',
          component: () => import('@/views/pages/LitigiosVer'),
          props: castRouteParams,
          meta: {
            permission: 'M_legales',
          },
        },
        {
          name: 'Consultas profesionales',
          path: '/ver/consultasMedicas',
          component: () => import('@/views/abms/altas/ConsultaMedica'),
          props: castRouteParams,
          // meta: {
            // permission: 'M_consultas_profesionales',
          // },
        },
        {
          name: 'Consultas profesionales pendientes',
          path: '/ver/consultasPendientes',
          component: () => import('@/views/abms/altas/ConsultaMedicaPendiente'),
          props: castRouteParams,
          // meta: {
            // permission: 'M_consultas_profesionales',
          // },
        },
        /*
        {
          name: 'Consultas medicas jugador',
          path: '/ver/consultasMedicas/:id',
          component: () => import('@/views/abms/altas/ConsultaMedicaJugador'),
          props: castRouteParams,
          meta: {
            permission: 'M_scouting',
          },
        },
        */ // esta demas
        /*
        {
          name: 'Acciones pendientes',
          path: '/ver/acciones',
          component: () => import('@/views/dashboard/Dashboard'),
          meta: {
            permission: 'M_scouting',
          },
        },
        */
        {
          name: 'Vencimientos',
          path: '/ver/vencimientos',
          component: () => import('@/views/pages/Vencimientos'),
          meta: {
            permission: 'M_contratos',
          },
        },
        {
          name: 'Pagos lista',
          path: '/ver/contabilidad/pagos/lista',
          component: () => import('@/views/pages/PagosLista'),
          meta: {
            permission: 'M_pagos',
          },
        },
        {
          // /mode/:mode/jugador/:idJugador?/contrato/:idContrato?/derecho/:idObligacion?
          name: 'Pagos',
          path: '/ver/contabilidad/pagos',
          component: () => import('@/views/pages/Pagos'),
          props: function (route) {
            return {
              mode: (String(route.params.mode) !== undefined) ? String(route.params.mode) : 'new',
              idJugador: Number(route.params.idJugador) || 0,
              idContrato: Number(route.params.idContrato) || 0,
              idObligacion: Number(route.params.idObligacion) || 0,
              idSolicitud: Number(route.params.idSolicitud) || 0,
            }
          },
          meta: {
            permission: 'M_pagos',
          },
        },
        {
          name: 'Facturas proveedores',
          path: '/ver/facturasp',
          component: () => import('@/views/abms/altas/FacturasProveedores'),
          meta: {
            permission: 'M_pagos',
          },
        },
        {
          name: 'Listado de Recibos',
          path: '/ver/contabilidad/cobros',
          component: () => import('@/views/pages/Cobros'),
          meta: {
            permission: 'M_cobros',
          },
        },
        {
          name: 'Cobros Pendientes',
          path: '/ver/contabilidad/cobros_pendientes',
          component: () => import('@/views/pages/CobrosPendientes'),
          meta: {
            permission: 'M_cobros',
          },
        },
        {
          name: 'Pagos Pendientes',
          path: '/ver/contabilidad/pagos_pendientes',
          component: () => import('@/views/pages/PagosPendientes'),
          meta: {
            permission: 'M_pagos',
          },
        },
        {
          name: 'Alta factura',
          path: '/alta/facturasprov/mode/:mode/fact/:facturaid?',
          component: () => import('@/views/abms/altas/FacturaProveForm'),
          props: function (route) {
            return {
              facturaid: Number(route.params.facturaid),
              mode: String(route.params.mode),
            }
          },
          meta: {
            permission: 'M_cobros',
          },
        },
        {
          name: 'Facturas',
          path: '/ver/facturas',
          component: () => import('@/views/pages/FacturasGeneradas'),
          meta: {
            permission: 'M_cobros',
          },
        },
        {
          name: 'Cuenta corriente jugador',
          path: '/ver/cuentaCorrienteJugador',
          component: () => import('@/views/pages/ResumenJugador.vue'),
          meta: {
            permission: 'M_resumen',
          },
        },
        {
          name: 'Cuenta corriente resumen',
          path: '/ver/cuentaCorrienteResumen',
          component: () => import('@/views/pages/ResumenCtaCorriente.vue'),
          meta: {
            permission: 'M_resumen',
          },
        },
        {
          name: 'Cuenta bancaria',
          path: '/alta/cuentaBancaria',
          component: () => import('@/views/pages/CuentasBancarias.vue'),
          meta: {
            permission: 'M_parametros',
          },
        },
        {
          name: 'Listado viaticos',
          path: '/ver/viaticos',
          component: () => import('@/views/pages/Viaticos'),
          meta: {
            permission: 'M_viaticos',
          },
        },
        {
          name: 'Cambiar contraseña',
          path: '/ver/cambiarContrasena',
          component: () => import('@/views/pages/UserPassword'),
          props: castRouteParams,
        },
        {
          name: 'Alta viaticos',
          path: '/ver/viaticos/:mode/:id',
          component: () => import('@/views/abms/altas/ViaticosForm'),
          props: castRouteParams,
          meta: {
            permission: 'M_viaticos',
          },
        },
        /*
        {
          name: 'Pendientes',
          path: '/ver/pendientes/viaticos',
          component: () => import('@/views/dashboard/Dashboard'),
          meta: {
            permission: 'M_scouting',
          },
        },
        */
        // HASTA ACA
      ],
    },
    {
      path: '*',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          path: '/404',
          name: '404',
          component: () => import('@/views/pages/Error'),
        },
        {
          name: '404 Error',
          path: '',
          component: () => import('@/views/pages/Error'),
        },
      ],
    },
  ],
})
  function castRouteParams (route) {
    return {
      id: Number(route.params.id),
      mode: String(route.params.mode),
    }
  }
  /*
  function castRouteParamsTwoIds (route) {
    return {
      id: Number(route.params.id),
      secondId: Number(route.params.secondId),
      mode: String(route.params.mode),
    }
  }
*/
